import loadable from '@loadable/component';

import { hydrateOnDemand } from 'utils/hydrateOnDemand/hydrateOnDemand';

export const ListingCountsLoadable = hydrateOnDemand(
  loadable(() => import('./ListingCounts'), {
    resolveComponent: (module) => module.ListingCounts,
  }),
);
